module.exports = __webpack_public_path__ + "static/HeaderConversation.fb81b157.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/HeaderConversation.svg
// module id = 503
// module chunks = 35783957827783